/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component, useState } from 'react';
import styles from './index.module.less';
import { getRechargedVoucherOrder, getAllVoucherOrder } from '../../../../services/api';
import { milliFormat, phoneNumFormat, parseDate } from '../../../../utils/tool';
import throttle from 'lodash/throttle'
import copy from 'copy-to-clipboard'

export default class TopupRecord extends Component {
    state = {
        userInfo: this.props.location.state.userInfo,
        currentOrderList: [],
        orderStatus: {
            '30': 'Đang xử lý',
            '31': 'Thành công',
            '32': 'Thất bại',
            '33': 'Thành công một phần',
        },
        showLoadingModal: false,
        loadingInfo: '',
        pageSize: 6,
        lastMinId: 0,
        noMoreData: false,
        showCopyModal: false,
        copySerialNum: '',
        copyPinNum: '',
        copyVendor: '',
        showTipsModal: false,
        tipsInfo: '',
        isRechargeCopy: false,
    };

    loadStatus = false;

    ref = React.createRef();

    componentDidMount() {
        this.showLoading();
        this.getProcessOrderList();
        const node = this.ref.current;
        this.scrollParent = this.getScrollParent(node);
        if (this.checkVisible(node)) {
            // this.setState({ loading: false });
        } else {
            this.addEvent();
        }
    }

    componentWillUnmount() {
        this.cancelEvent();
    }

    onScroll = throttle(() => {
        const { noMoreData } = this.state;
        const node = this.ref.current;
        if (this.checkVisible(node)) {
            if (!this.loadStatus && !noMoreData) {
                this.getProcessOrderList();
            }
        }
    }, 200)

    addEvent = () => {
        const scrollParent = this.scrollParent || window;
        scrollParent.addEventListener('scroll', this.onScroll);
    }

    cancelEvent = () => {
        const scrollParent = this.scrollParent || window;
        scrollParent.removeEventListener('scroll', this.onScroll);
    }


    getScrollParent = (node) => {
        if (!node || node.parentNode === document.documentElement) {
            return null;
        }
        const parentNode = node.parentNode;
        if (parentNode.scrollHeight > parentNode.clientHeight
            || parentNode.scrollWidth > parentNode.clientWidth
        ) {
            return parentNode;
        }
        return this.getScrollParent(parentNode);
    }

    checkVisible = (node) => {
        if (node) {
            const { top, bottom, left, right } = node.getBoundingClientRect();
            return (bottom > 0)
                && (top < window.innerHeight)
                && (left < window.innerWidth)
                && (right > 0);
        }
        return false;
    }

    showLoading = (info) => {
        this.setState({
            loadingInfo: info,
            showLoadingModal: true
        });
    }

    hideLoading = () => {
        this.setState({
            showLoadingModal: false,
            loadingInfo: ''
        });
    }

    getAllOrderList = () => {
        const { userInfo, currentOrderList, lastMinId, pageSize } = this.state;
        console.log('currentOrderList.length=' + currentOrderList.length);
        let data = {
            "app_id": 1,
            "user_id": userInfo.uid,
            "last_min_id": lastMinId + '',
            "page_size": pageSize
        }
        let hearder = {
            "app-id": 1,
            "user-id": userInfo ? userInfo.uid : '',
            "token": userInfo ? userInfo.login_token : '',
        };
        this.loadStatus = true;
        getAllVoucherOrder(data, hearder).then(res => {
            if (res && res.code === 0) {
                let minId = res.data[0].id;
                res.data.map((item, index) => {
                    if (item.id < minId) {
                        minId = item.id;
                    }
                });
                if (res.data.length < pageSize) {
                    this.setState({
                        noMoreData: true
                    })
                }
                this.loadStatus = false;
                this.setState({
                    lastMinId: minId,
                    currentOrderList: currentOrderList.concat(res.data)
                });
            }
            this.hideLoading();
        });
    }

    getProcessOrderList = () => {
        const { userInfo, currentOrderList, lastMinId, pageSize } = this.state;
        getRechargedVoucherOrder({
            "app_id": 1,
            "user_id": userInfo.uid,
            "last_min_id": lastMinId + '',
            "page_size": pageSize
            // "app_id": 1,
            // "user_id": "1234",
            // "LastMinId": "",
            // "vendor": "VIETTEL",
            // "page_size": 5
        }, {
                "app-id": 1,
                "user-id": userInfo ? userInfo.uid : '',
                "token": userInfo ? userInfo.login_token : '',
            }).then(res => {
                if (res && res.code === 0) {
                    let minId = res.data[0].order.id;
                    res.data.map((item, index) => {
                        if (item.id < minId) {
                            minId = item.id;
                        }
                    });
                    console.log("length=" + res.data.length + " pagesize=" + pageSize + "  minId=" + minId);
                    if (res.data.length < pageSize) {
                        this.setState({
                            noMoreData: true
                        })
                    }
                    this.loadStatus = false;
                    this.setState({
                        lastMinId: minId,
                        currentOrderList: currentOrderList.concat(res.data)
                    });
                }
                this.hideLoading();
            });
    }

    showCopyModal = () => {
        this.setState({ showCopyModal: true }, () => {
            setTimeout(() => {
                this.refs.copy_content.style.transform = 'translateY(0%)';
            }, 100);
        });
    }

    closeCopyModal = () => {
        return new Promise((resolve, reject) => {
            this.refs.copy_content.style.transform = 'translateY(100%)';
            setTimeout(() => {
                this.setState({ showCopyModal: false });
                return resolve('');
            }, 300);
        });
    }

    showTipsModal = (tips, time) => {
        this.setState({
            tipsInfo: tips,
            showTipsModal: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    tipsInfo: '',
                    showTipsModal: false
                });
            }, time);
        })
    }


    render() {
        const { currentOrderList, orderStatus, showLoadingModal, showCopyModal, loadingInfo, noMoreData, copySerialNum, copyPinNum, showTipsModal, tipsInfo, isRechargeCopy, copyVendor } = this.state;

        const renderContent = () => {
            if (currentOrderList.length > 0) {
                return currentOrderList.map((item, index) => {
                    let orderInfo = item.order;
                    let voucherInfo = item.vouchers;
                    let voucherDom = () => {
                        return voucherInfo.map((vItem, vIndex) => {
                            return <div className={styles.vouncherItem}>
                                <label className={styles.vouncherTitle}>
                                    <span className={styles.title}>{`Mã thẻ điện thoại ${vItem.voucher_vendor}`}</span>
                                    <span className={styles.amount} style={{ display: 'block', fontWeight: '300' }}>{`Mệnh giá: ${milliFormat(vItem.voucher_amount)}đ`}</span>
                                </label>
                                {/* <label className={styles.voucherInfo}>No: <span>{`${vIndex + 1}`}</span></label> */}
                                <label className={styles.voucherPin}><span>{`${vItem.voucher_pincode}`}</span></label>
                                <label className={styles.voucherInfo}>Số seri: <span>{`${vItem.voucher_id}`}</span></label>
                                <button onClick={() => {
                                    this.setState({
                                        copySerialNum: vItem.voucher_id,
                                        copyPinNum: vItem.voucher_pincode,
                                        copyVendor: vItem.voucher_vendor
                                    }, () => {
                                        this.setState({ isRechargeCopy: false }, () => {
                                            this.showCopyModal();
                                        });
                                    });
                                }}>Sao chép</button>
                                <button onClick={() => {
                                    this.setState({
                                        copySerialNum: vItem.voucher_id,
                                        copyPinNum: vItem.voucher_pincode,
                                        copyVendor: vItem.voucher_vendor
                                    }, () => {
                                        this.setState({ isRechargeCopy: true }, () => {
                                            this.showCopyModal();
                                        });
                                    });
                                }}>Nạp ngay</button>
                            </div>
                        });
                    }
                    return <div ref={index == currentOrderList.length - 2 ? this.ref : null} className={styles.historyItem} key={index}>
                        <div className={styles.historyTitle}>
                            <span className={styles.orderNum}>{orderInfo.order_code}</span>
                            <span className={styles.orderDate}>{parseDate(orderInfo.create_time)}</span>
                        </div>
                        <div className={styles.voucherWrapper}>
                            {voucherDom()}
                        </div>
                    </div>
                });
            } else {
                let voucherDom = () => {
                    return <div className={styles.vouncherItem}>
                        <label className={styles.vouncherTitle}>
                            <span className={styles.title}>{`Demo: Mã thẻ điện thoại ${'VIETTEL'}`}</span>
                            <span className={styles.amount} style={{ display: 'block', fontWeight: '300' }}>{`Mệnh giá: ${milliFormat(10000)}đ`}</span>
                        </label>
                        {/* <label className={styles.voucherInfo}>No: <span>{`${vIndex + 1}`}</span></label> */}
                        <label className={styles.voucherPin}><span>{`${'000000000000000'}`}</span></label>
                        <label className={styles.voucherInfo}>Số seri: <span>{`${'00000000000000'}`}</span></label>
                        <button onClick={() => {
                            this.setState({
                                copySerialNum: '00000000000000',
                                copyPinNum: '000000000000000',
                                copyVendor: 'VIETTEL'
                            }, () => {
                                this.setState({ isRechargeCopy: false }, () => {
                                    this.showCopyModal();
                                });
                            });
                        }}>Sao chép</button>
                        <button onClick={() => {
                            this.setState({
                                copySerialNum: '00000000000000',
                                copyPinNum: '000000000000000',
                                copyVendor: 'VIETTEL'
                            }, () => {
                                this.setState({ isRechargeCopy: true }, () => {
                                    this.showCopyModal();
                                });
                            });
                        }}>Nạp ngay</button>
                    </div>
                }
                return <div className={styles.historyItem}>
                    <div className={styles.historyTitle}>
                        <span className={styles.orderNum}>{'Demo'}</span>
                        <span className={styles.orderDate}>{parseDate('2021-07-01T00:00:00Z')}</span>
                    </div>
                    <div className={styles.voucherWrapper}>
                        {voucherDom()}
                    </div>
                </div>
            }
        }

        return <>
            <div className={styles.tab_wrapper}>
                {renderContent()}
                {noMoreData ? <div className={styles.moreDataWrapper}>
                    <hr />
                    Không còn dữ liệu thêm
                </div> : null}
            </div>
            {showCopyModal ? <div className={styles.copyModal}>
                <div className={styles.copyBlank} onClick={this.closeCopyModal}></div>
                <div className={styles.copyContent} ref='copy_content'>
                    <span className={styles.copyTitle}>Sao chép thẻ nạp</span>
                    <div className={styles.copyCloseBtn} onClick={() => {
                        this.closeCopyModal();
                    }}><svg t="1627529805036" style={{ position: 'absolute' }} viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1967" width="20" height="20"><path d="M519.02036023 459.47959989L221.8941505 162.35411435a37.07885742 37.07885742 0 1 0-52.45354772 52.40502656l297.12476134 297.15010821L169.44060278 809.05863314a37.07885742 37.07885742 0 1 0 52.42964924 52.42892505l297.15010821-297.12476136 297.15010822 297.12476136a37.07885742 37.07885742 0 1 0 52.42892504-52.40430237l-297.12476135-297.1740067 297.12476135-297.12548553a37.07885742 37.07885742 0 1 0-52.42892504-52.42964924L519.04498291 459.47959989z" p-id="1968"></path></svg></div>
                    <ul>
                        {!isRechargeCopy ? <li className={styles.copyItem} onClick={() => {
                            let clipBoardContent = `Số seri: ${copySerialNum} Số thẻ: ${copyPinNum}`;
                            copy(clipBoardContent);
                            this.closeCopyModal().then(res => {
                                this.showTipsModal('Copy success!', 2000);
                            });
                        }}>
                            <span className={styles.itemTitle}>sao chép mã thẻ và số seri</span>
                            <label>Số thẻ: <span>{copyPinNum}</span></label>
                            <label>Số seri: <span>{copySerialNum}</span></label>
                        </li> : null}
                        {!isRechargeCopy ? <li className={styles.copyItem} onClick={() => {
                            let clipBoardContent = copyPinNum;
                            copy(clipBoardContent);
                            this.closeCopyModal().then(res => {
                                this.showTipsModal('Copy success!', 2000);
                            });
                        }}>
                            <span className={styles.itemTitle}>Sao chép mã thẻ</span>
                            <span>{copyPinNum}</span>
                        </li> : null}
                        {!isRechargeCopy ? <li className={styles.copyItem} onClick={() => {
                            let clipBoardContent = copySerialNum;
                            copy(clipBoardContent);
                            this.closeCopyModal().then(res => {
                                this.showTipsModal('Copy success!', 2000);
                            });
                        }}>
                            <span className={styles.itemTitle}>Sao chép số seri</span>
                            <span>{copySerialNum}</span>
                        </li> : null}
                        <li className={styles.copyItem} onClick={() => {
                            let clipBoardContent = `*100*${copyPinNum}#`;
                            copy(clipBoardContent);
                            this.closeCopyModal().then(res => {
                                this.showTipsModal('Copy success!', 2000);
                            });
                        }}>
                            <span className={styles.itemTitle}>Sao chép cú pháp nạp thẻ trả trước</span>
                            <span>{`*100*${copyPinNum}#`}</span>
                        </li>
                        <li className={styles.copyItem} onClick={() => {
                            let clipBoardContent = `*188*0*$${copyPinNum}#`;
                            copy(clipBoardContent);
                            this.closeCopyModal().then(res => {
                                this.showTipsModal('Copy success!', 2000);
                            });
                        }}>
                            <span className={styles.itemTitle}>Sao chép cú pháp nạp thẻ trả sau</span>
                            <span>{`${copyVendor === 'VIETTEL' ? '*199*' : (copyVendor === 'MOBIFONE' ? '*100*' : '*188*0*')}$${copyPinNum}#`}</span>
                        </li>
                    </ul>
                </div>
            </div> : null}
            {showTipsModal ? <div className={styles.tipsModal}>
                <div className={styles.tips}>{tipsInfo}</div>
            </div> : null}
            {showLoadingModal ? <div className={styles.loadingModal}>
                <div className={styles.loading}>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                {loadingInfo ? <div className={styles.loadingTxt}>{loadingInfo}</div> : null}
            </div> : null}
        </>
    }
}